import blogBg from "../../../../app/assets/images/blog-bg.webp";

export const marketingAssets = {
  blog: {
    award1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blog/award1.webp`,
    award2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blog/award2.webp`,
    blogSlider1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blog/blog-slider-1.webp`,
    blogBg: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blog/blog-bg.webp`,
    blogCard1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blog/blog-card-1.webp`,
    blogCard2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blog/blog-card-2.webp`,
    blogCard3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blog/blog-card-3.webp`,
    bg: blogBg,
  },
  blogDetails: {
    blog1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blog-details/blog1.webp`,
    blog2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blog-details/blog2.webp`,
    blog3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blog-details/blog3.webp`,
    blog4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blog-details/blog4.webp`,
    blog5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blog-details/blog5.webp`,
    blog6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blog-details/blog6.webp`,
    auther: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blog-details/auther.webp`,
    linkidin: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blog-details/linkidin.svg`,
    quote: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blog-details/quote.webp`,
    subscribeBg: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blog-details/subscribe-bg.webp`,
  },
  awards: {
    award1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/award-1.webp`,
    award2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/award-2.webp`,
    award3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/award-3.webp`,
    award4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/award-4.webp`,
  },
  testimonial: {
    quote: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/testimonial/testimonial-quote.svg`,
    borderTopRight: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/testimonial/border-top-right.svg`,
    borderBottomLeft: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/testimonial/border-bottom-left.svg`,
    user1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/testimonial/user1.webp`,
    t1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/testimonial/testimonial-1.webp`,
    t2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/testimonial/testimonial-2.webp`,
    t3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/testimonial/testimonial-3.webp`,
    t4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/testimonial/testimonial-4.webp`,
    bg: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/testimonial/testimonial-bg.webp`,
    quoteEnd: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/testimonial/quote-end.svg`,
    quoteStart: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/testimonial/quote-start.svg`,
  },
  portfolio: {
    portfolio1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/portfolio/portfolio-1.webp`,
    portfolio2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/portfolio/portfolio-2.webp`,
    portfolio3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/portfolio/portfolio-3.webp`,
    portfolio4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/portfolio/portfolio-4.webp`,
    portfolio5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/portfolio/portfolio-5.webp`,
    portfolio6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/portfolio/portfolio-6.webp`,
  },
  flatAwards: {
    award1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/award1.webp`,
    award2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/award2.webp`,
    award3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/award3.webp`,
    award4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/award4.webp`,
    award5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/award5.webp`,
    award6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/award6.webp`,
    awardImage1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/clutch-winner-fall-2025.webp`,
    awardImage2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/clutch-champion-fall-2025.webp`,
    awardImage3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/clutch-winner-spring-2025.webp`,
    awardImage4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/softwareworldai.webp`,
    awardImage5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/top-app-developers-itfirms-badge-2025.webp`,
    awardImage6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/techbehemoths-award.webp`,
    awardImage7: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/businessofapps.webp`,
    awardImage8: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/upfirms.webp`,
    awardImage9: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/themanifest.webp`,
    awardImage10: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/goodfirms.webp`,
    awardImage11: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/extract.webp`,
    awardImage12: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/topdevelopers.webp`,
    awardImage13: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/tabbyawards-2018.webp`,
    awardImage14: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/softwareworldapp.webp`,
    awardImage15: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/mobileappdaily.webp`,
    awardImage16: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/g2.webp`,
    awardImage17: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/techreviewer.webp`,
    awardImage18: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/siliconindia.webp`,
    awardImage19: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/designrush-web.webp`,
    awardImage20: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/selectedfirms-web.webp`,
    awardImage21: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/upvoted-app.webp`,
    awardImage22: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/serchen.webp`,
    awardImage23: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/awards/top-mobile-app-development-company.webp`,
  },
};
